module.exports = function (options) {
  return INKIVE.C.IS_MOBILE
    ? options.fn(this)
    : options.inverse(this);
};
